import { ReactElement } from 'react';

import Image from '../../UI/Image';
import Richtext from '../../UI/Richtext';
import CTA from '../../UI/Cta';
import { IComponentSimpleHeroImageLeftTextRightFields } from 'types/contentful';

export interface SimpleHeroProps extends IComponentSimpleHeroImageLeftTextRightFields {
  rightImage?: boolean;
}

export default function SimpleHeroImageLeftTextRight({
  heading,
  body,
  image,
  colorScheme,
  cta,
  rightImage,
}: SimpleHeroProps): ReactElement {
  const [background, highlight] = colorScheme.split('-');

  return (
    <div
      className={`flex flex-col lg:min-h-heading ${
        rightImage ? 'lg:flex-row-reverse' : 'lg:flex-row'
      }`}
    >
      <div className="w-full lg:w-3/5">
        <Image image={image} query="w=840&h=600" classNames="h-full w-full object-cover" />
      </div>
      <div
        className={`mx-6 -mt-16 lg:mx-0 lg:mt-0 lg:w-2/5 p-4 lg:px-12 lg:pt-16 overflow-visible bg-${background}`}
      >
        <Richtext
          highlight={highlight}
          document={heading}
          classNames={`font-heading text-hero-mobile lg:text-hero-desktop`}
        />
        <div className="my-8">
          {body && <Richtext document={body} classNames="text-sm lg:text-lg leading-relaxed" />}
        </div>
        {cta && <CTA {...cta.fields} backgroundColor={background} />}
      </div>
    </div>
  );
}
